import angular from "angular";
import { CashdrawerPaymentDialog } from "../dialog/cashdrawer-payment-dialog/cashdrawer-payment-dialog";
import { VneCashdrawerDriver } from "./vne-cashdrawer-driver";

import {
    DigitalPaymentHandler,
    DigitalPaymentHandlerOptions,
    DigitalPaymentHandlerResult
} from "src/app/shared/model/digital-payments.model";

import {
    DocumentPrintHook,
    DocumentPrinterOptions
} from "src/app/shared/model/document-printer.model";

import {
    PaymentMethods,
    Sales,
    SalesPayments
} from "tilby-models";

import {
    EntityManagerService
} from "src/app/core";

class VneCashdrawer implements DigitalPaymentHandler, DocumentPrintHook {
    static $inject = [
        "$translate",
        "$filter",
        "CashdrawerPaymentDialog",
        "VneCashdrawerDriver",
        "entityManager"
    ];

    constructor(
        private $translate: any,
        private $filter: any,
        private CashdrawerPaymentDialog: CashdrawerPaymentDialog,
        private VneCashdrawerDriver: VneCashdrawerDriver,
        private entityManager: EntityManagerService
    ) {
    }

    public getPaymentReceipt(paymentMethod: SalesPayments): string {
        if(!paymentMethod.payment_data) {
            return "";
        }

        const transaction = JSON.parse(paymentMethod.payment_data);

        const receiptTail = [
            "",
            "Dettaglio pagamento",
            `ID transazione ${String(transaction.idTransaction).padStart(20, ' ')}`,
            `Pagato ${this.$filter('sclCurrency')(transaction.paid).padStart(25, ' ')}`,
            `Resto erogato ${this.$filter('sclCurrency')(transaction.changeGiven).padStart(18, ' ')}`,
            `Resto non erogato ${this.$filter('sclCurrency')(transaction.changeNotGiven).padStart(14, ' ')}`,
        ];

        return receiptTail.join('\n');
    }

    public async payment(amount: number, options: DigitalPaymentHandlerOptions): Promise<DigitalPaymentHandlerResult> {
        const paymentMethod = options.paymentMethod;

        if (!paymentMethod.schema_name) {
            throw this.$translate.instant('DIGITAL_PAYMENTS.COMMON.SCHEMA_NAME_NOT_FOUND');
        }

        return this.CashdrawerPaymentDialog.show(amount, options.paymentMethod, this.VneCashdrawerDriver, "Cassetto Vne");
    }

    public async deposit(amount: number, options: { paymentMethod: PaymentMethods; }): Promise<DigitalPaymentHandlerResult> {
        const paymentMethod = options.paymentMethod;

        if (!paymentMethod.schema_name) {
            throw this.$translate.instant('DIGITAL_PAYMENTS.COMMON.SCHEMA_NAME_NOT_FOUND');
        }

        return this.CashdrawerPaymentDialog.show(amount, options.paymentMethod, this.VneCashdrawerDriver, "Cassetto Vne", 'DEPOSIT');
    }

    public isEnabled(): boolean {
        return true;
    }

    public async printFailHook(sale: Sales, printerDocumentData: DocumentPrinterOptions): Promise<string | undefined> {
        const payment = sale.payments?.find((payment) => payment.payment_method_type_id == 38);

        if(!payment) {
            return;
        }

        const paymentMethod = await this.entityManager.paymentMethods.fetchOneOffline(payment.payment_method_id);
        const baseUrl = `https://${paymentMethod?.schema_name}/selfcashapi`;

        try {
            await this.VneCashdrawerDriver.rollbackPayment(baseUrl);
        } catch(err) {
            //TODO: return error code to notify missed rollback
        }
    }
}

angular.module('digitalPayments').service('VneCashdrawer', VneCashdrawer);